import React, { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import DeleteAdv from "../../components/modals/news/DeleteNews";
import EditAdvs from "../../components/modals/news/EditNews";
import Details from "../../components/modals/news/details";

const AdvsItem = ({ news, isAuthenticated, user }) => {
  const { _id, image, title, discription, updatedAt } = news;

  return (
    <div className="col s12 " style={{ direction: "rtl" }}>
      <div className="card grid-2">
        <div className="card-image">
          <img src={image} alt={title} />
          <br />
          {isAuthenticated && user && user.rolls === 2 && (
            <Fragment>
              <EditAdvs correntNews={news} />
              <DeleteAdv id={_id} />
            </Fragment>
          )}

          
        </div>
        <div className="card-stacked">
          <div className="card-content right-align">
            <h5>
              {" "}
             {title} 
            </h5>
            <small>{updatedAt}</small>
            <p className="text-over" dangerouslySetInnerHTML={{ __html: discription }}></p>
            <Details news={news} />
          </div>
        </div>
      </div>
    </div>
  );
};

AdvsItem.propTypes = {
  adv: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
});
export default connect(mapStateToProps)(AdvsItem);
